import React from "react";
import "./MissionVisionVangal.css";

export default function MissionVisionVangal() {
  return (
    <section className="vangal-mv-section">

      <h2 className="vangal-mv-heading anim anim-bottom">Our Mission & Vision</h2>

      <div className="vangal-mv-container">

        {/* Mission Block */}
        <div className="vangal-mv-card anim anim-top">
          <h3 className="vangal-mv-title">Our Mission</h3>
          <p className="vangal-mv-text">
            Our mission is to deliver pure, hygienic, and traditionally crafted 
            dairy products that maintain the authentic homemade taste. We aim to 
            uphold ethical sourcing, adopt the best manufacturing practices, and 
            ensure that every Vangal and Gopika product brings health, trust, and 
            satisfaction to every household.
          </p>
        </div>

        {/* Vision Block */}
        <div className="vangal-mv-card anim anim-top">
          <h3 className="vangal-mv-title">Our Vision</h3>
          <p className="vangal-mv-text">
            Our vision is to become a leading dairy brand known for purity, 
            craftsmanship, and traditional flavours. We aspire to expand our 
            footprint across India while maintaining our commitment to 
            preservative-free production, artisanal quality, and a deeper 
            connection between farmers and consumers.
          </p>
        </div>

      </div>
    </section>
  );
}
